import { Model } from './model';
export class Suggerimento extends Model {
  static apiUrl: string = "suggerimenti";

  campo: string;
  titolo: string;
  testo: string;
  ordinale: number;

  deserialize(input: any): Suggerimento {
    let retV: Suggerimento = new Suggerimento();

    retV = super.deserialize(input) as Suggerimento;
    return retV;
  }

  public getHumanIdentifier() {
    return this.titolo;
  }
}
